import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Inputfield from '../Inputfield/Inputfield'
import classNames from 'classnames'
import DatePicker, { registerLocale } from 'react-datepicker'
import { sv } from 'date-fns/locale'
import moment from 'moment'
import styles from './DateTimePicker.module.css'

registerLocale('sv-se', sv)

export default class DateTimePicker extends Component {
  static propTypes = {
    date: PropTypes.string,
    dateInvalid: PropTypes.bool,
    disabled: PropTypes.bool,
    errorMessageDate: PropTypes.string,
    errorMessageTime: PropTypes.string,
    hoursInvalid: PropTypes.bool,
    minutesInvalid: PropTypes.bool,
    onDateChange: PropTypes.func,
    onTimeBlur: PropTypes.func,
    onTimeChange: PropTypes.func,
    onTimePartChange: PropTypes.func,
    time: PropTypes.string,
    title: PropTypes.string
  }

  constructor (props) {
    super(props)
    this.state = {
      disabled: props.disabled,
      minDate: moment(),
      maxDate: moment().add(89, 'days'),
      dateHasError: false,
      typedDate: null
    }
    this._onTimeBlur = this._onTimeBlur.bind(this)
    this._onHoursChange = this._onHoursChange.bind(this)
    this._onMinutesChange = this._onMinutesChange.bind(this)
    this._onDateTyped = this._onDateTyped.bind(this)
    this._onDatePicked = this._onDatePicked.bind(this)
    this._onDateBlur = this._onDateBlur.bind(this)
  }

  _onDateTyped (event) {
    if (event.target.nodeName !== 'INPUT') return
    this.setState({ typedDate: event.target.value })
  }

  _onDatePicked (value) {
    this.setState({ typedDate: null })
    this.props.onDateChange(value ? moment(value) : null)
  }

  _onDateBlur (event) {
    if (event.target.nodeName !== 'INPUT') return
    this.props.onDateChange(event)
  }

  _onTimeBlur () {
    this.props.onTimeBlur(this.state.hours, this.state.minutes)
  }

  _onHoursChange (event) {
    const value = event.target.value
    this.props.onTimePartChange(value + ':' + this.state.minutes)
  }

  _onMinutesChange (event) {
    const value = event.target.value
    this.props.onTimePartChange(this.state.hours + ':' + value)
  }

  render () {
    const { errorMessageDate, errorMessageTime, time, title, date, dateInvalid, hoursInvalid, minutesInvalid } = this.props
    const t = time.split(':')
    if (t.length == 2) {
      /* eslint-disable react/no-direct-mutation-state */
      this.state.hours = t[0]
      this.state.minutes = t[1]
      /* eslint-enable react/no-direct-mutation-state */
    }
    const datePickerClasses = classNames('date-picker', { 'has-error': dateInvalid })
    const hoursClasses = classNames({ 'has-error': hoursInvalid })
    const minutesClasses = classNames({ 'has-error': minutesInvalid })

    return (
      <div className={styles['date-picker-container']}>
        <h2>{title}</h2>       
        <div className={styles.row}>
          <div className={styles['date-wrapper']} onBlur={this._onDateBlur}>
          <DatePicker
            className={datePickerClasses}
            dateFormat="yyyy-MM-dd"
            locale="sv-se"
            maxDate={this.state.maxDate.toDate()}
            minDate={this.state.minDate.toDate()}
            onChange={this._onDatePicked}
            onChangeRaw={this._onDateTyped}
            popperPlacement="bottom-start"
            selected={moment(date).toDate()}
            value={this.state.typedDate === null ? undefined : this.state.typedDate}
          />
          </div>
          <div className={styles['time-wrapper']}>
            <Inputfield
              inputClasses={hoursClasses}
              max="23"
              min="0"
              onBlur={this._onTimeBlur}
              onChange={this._onHoursChange}
              type="number"
              value={this.state.hours} 
            />
            <span className={styles['time-separator']}>:</span>
            <Inputfield
              errorMessage={errorMessageDate ? errorMessageDate : errorMessageTime}
              inputClasses={minutesClasses}
              max="59"
              min="0"
              onBlur={this._onTimeBlur}
              onChange={this._onMinutesChange}
              type="number"
              value={this.state.minutes} 
            />
          </div>
        </div>
      </div>
    )
  }
}
